<div class="container-fluid">
  <div class="row pt-4" style=" display: flex;align-items: center;margin-bottom: 3%;">
    <div class="col-md-7 px-0 w-100">
      <p class="m-0 text-uppercase" style="font-size: 20px;color: #262756;font-weight: bold;">boitiers</p>
      <small class="text-uppercase" style="font-size:15px;color: #959090;">Gestion des boitiers </small>
    </div>
  </div>
  <ngx-spinner *ngIf="spinnerActiveVehiculeTrameData != false" bdColor="rgba(100,112,124,0.56)" size="medium"
               color="#233547" type="ball-clip-rotate-multiple" [fullScreen]="true">
    <p style="color: white"></p>
  </ngx-spinner>

  <div class="row px-0 ">
    <div class="col-2">
      <div class="export-icons d-flex mb-2">
        <div class="icn-sec">
          <img (click)="exportDeviceTable(exportDirective, 'xlsx')" src="assets/newImages/excel-svg.svg"
               ngbTooltip="Expoter EXCEL"/>
        </div>
        <div class="icn-sec">
          <img (click)="exportDeviceTablePDF()" src="assets/newImages/pdf-svg.svg" ngbTooltip="Expoter PDF"/>
        </div>
      </div>
    </div>
    <div class="col-2">
    </div>
    <div class="col-1">
      <mat-form-field appearance="fill">
        <mat-label>Filtrer par</mat-label>
        <mat-select [disabled]="disableFiltreBydates" #value1>
          <mat-option selected (click)="FilterPeriode(1)" value="1 jour">
            1 jour
          </mat-option>
          <mat-option selected (click)="FilterPeriode(7)" value="7 jours" >
            7 jours
          </mat-option>
          <mat-option selected (click)="FilterPeriode(30)" value="1 mois">
            1 mois
          </mat-option>
          <mat-option selected (click)="FilterPeriode(60)" value="2 mois" >
            2 mois
          </mat-option>
          <mat-option selected (click)="FilterPeriode(180)" value="6 mois" >
            6 mois
          </mat-option>
          <mat-option selected (click)="FilterPeriode(365)" value="1 année">
            1 année
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>


    <div class="col-2">
      <mat-form-field appearance="fill">
        <mat-label>Filtrer par date Début-Fin</mat-label>
        <input autocomplete="off" readonly [min]="dateMin" [max]="dateMax"
               [disabled]=" spinnerActive != false || getdt ==null   ? 'disabled' : null" matInput #input id="dateTime"
               [(ngModel)]="dateTime" [selectMode]="'range'" [owlDateTime]="dt10" [owlDateTimeTrigger]="dt10"
               [owlDateTimeTrigger]="dt10"/>
        <button [disabled]="spinnerActive != false || getdt ==null  ? 'disabled' : null" mat-button matSuffix
                mat-icon-button [owlDateTimeTrigger]="dt10" [owlDateTimeTrigger]="dt10">
          <mat-icon>date_range</mat-icon>
        </button>

        <button placement="bottom" ngbTooltip="Valider"
                [disabled]=" spinnerActive != false || getdt ==null  ? 'disabledColor' : null" mat-button matSuffix
                mat-icon-button class="BoitierDateSelect">
          <mat-icon (click)="getRangeDateDevice()">done_all</mat-icon>
        </button>
        <button [disabled]=" spinnerActive != false || getdt ==null  ? 'disabledColor' : null" placement="bottom"
                ngbTooltip="réinitialiser" [disabled]=" spinnerActive != false || getdt ==null  ? 'disabled' : null"
                (click)="resetDate()" mat-button matSuffix mat-icon-button>
          <mat-icon>format_color_reset</mat-icon>
        </button>
        <owl-date-time [pickerType]="'calendar'" [minDays]='minDays' [maxDays]='maxDays' #dt10></owl-date-time>
      </mat-form-field>
    </div>
    <div class="col-2">
      <mat-form-field style="background: #F0F0F0 0% 0% no-repeat padding-box;
          border-radius: 10px;
          opacity: 1;" appearance="fill" (click)="hiddencontenu()">
        <mat-label>Filtrer par ID véhicule</mat-label>

        <input type="text" aria-label="Number" (keyup)="applyFilter1($event)" (click)="hiddencontenu2()" matInput
               [formControl]="myControl" [matAutocomplete]="auto" #input id="getdt" name="getdt"
               value="{{ itemSelect2 }}"/>

        <button mat-button matSuffix mat-icon-button class="BoitierRefrechVehicule">
          <mat-icon placement="bottom" ngbTooltip="Actualiser les données des véhicules" (click)="refrech()">
            refresh
          </mat-icon>
        </button>
        <button placement="bottom" ngbTooltip="réinitialiser"
                (click)="value1.value='';resetDataFromUnit()" mat-button matSuffix mat-icon-button>
          <mat-icon>format_color_reset</mat-icon>
        </button>
        <button mat-button (click)="hiddencontenu()" matSuffix mat-icon-button>
          <mat-icon placement="bottom" ngbTooltip="Liste vehicule">filter_list</mat-icon>

        </button>

        <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete">
          <ngx-spinner *ngIf="spinnerActiveVehicule != false" bdColor="rgba(100,112,124,0.56)" size="medium"
                       color="#233547" type="ball-clip-rotate-multiple" [fullScreen]="false">
            <p style="color: white"></p>
          </ngx-spinner>

          <table *ngIf="hiddenContenu == 'true'" class="table-hover" mat-table [dataSource]="dataSourcet">

            <ng-container matColumnDef="position">
              <th mat-header-cell *matHeaderCellDef>No.</th>
              <td (click)="getUserr(elementt.id)" mat-cell *matCellDef="let elementt" [ngClass]="{
                        highlight: selectedRowIndex2 == elementt.id
                      }" (click)="getItemDetails2(elementt)">
                <b style="color: #262756;"> Véhicule : </b> {{ elementt?.name }} <br/>
                <b style="color: #262756;"> ID : </b> {{ elementt?.id }} <br/>
                <b style="color: #262756;"> DeviceID : </b> {{ elementt?.device_id }}
              </td>
            </ng-container>

            <tr class="d-none" mat-header-row *matHeaderRowDef="displayedColumnst"></tr>
            <tr mat-row *matRowDef="let elementt; columns: displayedColumnst"></tr>
          </table>

          <mat-paginator #secondPaginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>

          <mat-option class="d-none"></mat-option>
        </mat-autocomplete>
      </mat-form-field>
    </div>
    <div class="col-2" style="margin-top: 10px; font-weight: 600;">
      <div aria-expanded="false" aria-controls="collapseMalasngoding" style="margin-left: 17%;"
           [ngClass]="{'disabledCommunication': spinnerActive != false || getdt ==null}">
        <a type="button" class="my-a" data-toggle="collapse" (click)="openComunicaion(communication)"
           data-target="#collapseMalasngoding1">communication</a>
      </div>
    </div>
  </div>
  <hr style="border: 1px solid #e8e4e4; margin-top: 2%;">
  <div class="col-12">
    <!-- first side  -->
    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-3 w-100 pl-0">
      <div class="row">

        <!-- <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-12 w-100 ">
          <div class="list-group mb-2" id="list-tab" role="tablist">
            <a class="list-group-item list-group-item-action active" id="list-home-list" data-toggle="list"
              href="#list-home" role="tab" aria-controls="home" (click)="Device_Stepper_goBack(stepper)">
              <svg width="15px" height="16px" viewBox="0 0 16 16" class="bi bi-envelope" fill="currentColor"
                xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd"
                  d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4zm2-1a1 1 0 0 0-1 1v.217l7 4.2 7-4.2V4a1 1 0 0 0-1-1H2zm13 2.383l-4.758 2.855L15 11.114v-5.73zm-.034 6.878L9.271 8.82 8 9.583 6.728 8.82l-5.694 3.44A1 1 0 0 0 2 13h12a1 1 0 0 0 .966-.739zM1 11.114l4.758-2.876L1 5.383v5.73z" />
              </svg> &nbsp;&nbsp;Messages entrants <i (click)="getUserrefrech()"
                [ngClass]="{'disabledCommunication':   spinnerActive != false || getdt ==null }" placement="right"
                ngbTooltip="Actualiser" class="fas fa-retweet boitierRefrechAll"></i> </a>

            <a class="list-group-item list-group-item-action" id="list-profile-list" data-toggle="list"
              href="#list-profile" role="tab" aria-controls="profile" (click)="Device_Stepper_goForward(stepper)">

              <svg width="15px" height="16px" viewBox="0 0 16 16" class="bi bi-envelope-open" fill="currentColor"
                xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd"
                  d="M8.47 1.318a1 1 0 0 0-.94 0l-6 3.2A1 1 0 0 0 1 5.4v.818l5.724 3.465L8 8.917l1.276.766L15 6.218V5.4a1 1 0 0 0-.53-.882l-6-3.2zM15 7.388l-4.754 2.877L15 13.117v-5.73zm-.035 6.874L8 10.083l-6.965 4.18A1 1 0 0 0 2 15h12a1 1 0 0 0 .965-.738zM1 13.117l4.754-2.852L1 7.387v5.73zM7.059.435a2 2 0 0 1 1.882 0l6 3.2A2 2 0 0 1 16 5.4V14a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V5.4a2 2 0 0 1 1.059-1.765l6-3.2z" />
              </svg>&nbsp;&nbsp;Messages sortants</a>
          </div>
        </div> -->

        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 w-100  ">

        </div>
      </div>
    </div>
    <!-- fin de side  -->
  </div>
  <div class="col-12">
    <div class="col-12">
      <!-- <div class="row mb-3">
        <div class="col-xs-6 col-sm-6 col-md-6  col-lg-6 col-xl-2 w-100 pl-0">
          <mat-form-field appearance="fill">
            <mat-label>Page</mat-label>
            <mat-select
              [disabled]="dataSource?.data?.length === 0 ||   spinnerActive != false || getdt ==null   ? 'disabled' : null">
              <mat-option *ngFor="let item of collection" (click)="updateManualPage(item - 1)" [value]="item">
                {{ item }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="col-xs-6 col-sm-6 col-md-6 pb-md-3 pb-sm-3 pb-xs-3  col-lg-6 col-xl-2 w-100">
          <mat-form-field appearance="fill">
            <mat-label>Elément</mat-label>

            <mat-select [(ngModel)]="pageSize"
              [disabled]="dataSource?.data.length ===0 ||  spinnerActive != false || getdt ==null  ? 'disabled' : null">
              <mat-option (click)="updateManualPage2(pageSize)" *ngFor="let pageSize of pageSizeOptions"
                [value]="pageSize">
                {{ pageSize }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="col-xs-6 col-sm-6 col-md-6  pb-md-3 pb-sm-3 pb-xs-3 col-lg-6 col-xl-4 pl-0 w-100">
          <mat-form-field appearance="fill">
            <mat-label>Filtrer par date Début-Fin</mat-label>
            <input autocomplete="off" readonly [min]="dateMin" [max]="dateMax"
              [disabled]=" spinnerActive != false || getdt ==null   ? 'disabled' : null" matInput #input id="dateTime"
              [(ngModel)]="dateTime" [selectMode]="'range'" [owlDateTime]="dt10" [owlDateTimeTrigger]="dt10"
              [owlDateTimeTrigger]="dt10" />
            <button [disabled]="spinnerActive != false || getdt ==null  ? 'disabled' : null" mat-button matSuffix
              mat-icon-button [owlDateTimeTrigger]="dt10" [owlDateTimeTrigger]="dt10">
              <mat-icon>date_range</mat-icon>
            </button>

            <button placement="bottom" ngbTooltip="Valider"
              [disabled]=" spinnerActive != false || getdt ==null  ? 'disabledColor' : null" mat-button matSuffix
              mat-icon-button class="BoitierDateSelect">
              <mat-icon (click)="getRangeDateDevice()">done_all</mat-icon>
            </button>
            <button [disabled]=" spinnerActive != false || getdt ==null  ? 'disabledColor' : null" placement="bottom"
              ngbTooltip="réinitialiser" [disabled]=" spinnerActive != false || getdt ==null  ? 'disabled' : null"
              (click)="resetDate()" mat-button matSuffix mat-icon-button>
              <mat-icon (click)="resetDate()">format_color_reset</mat-icon>
            </button>
            <owl-date-time [pickerType]="'calendar'" [minDays]='minDays' [maxDays]='maxDays' #dt10></owl-date-time>
          </mat-form-field>
        </div>


        <div class="col-xs-6 col-sm-6 col-md-6    col-lg-6 col-xl-4 w-100">

          <form>
            <mat-form-field appearance="fill" (click)="hiddencontenu()">
              <mat-label>Filtrer par ID véhicule</mat-label>

              <input type="text" aria-label="Number" (keyup)="applyFilter1($event)" (click)="hiddencontenu2()" matInput
                [formControl]="myControl" [matAutocomplete]="auto" #input id="getdt" name="getdt"
                value="{{ itemSelect2 }}" />



              <button mat-button matSuffix mat-icon-button class="BoitierRefrechVehicule">
                <mat-icon placement="bottom" ngbTooltip="Actualiser les données des véhicules" (click)="refrech()">
                  refresh</mat-icon>

              </button>
              <button mat-button (click)="hiddencontenu()" matSuffix mat-icon-button>
                <mat-icon placement="bottom" ngbTooltip="Liste vehicule">filter_list</mat-icon>

              </button>


              <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete">
                <ngx-spinner *ngIf="spinnerActiveVehicule != false" bdColor="rgba(100,112,124,0.56)" size="medium"
                  color="#233547" type="ball-clip-rotate-multiple" [fullScreen]="false">
                  <p style="color: white"> </p>
                </ngx-spinner>

                <table *ngIf="hiddenContenu == 'true'" class="table-hover" mat-table [dataSource]="dataSourcet">

                  <ng-container matColumnDef="position">
                    <th mat-header-cell *matHeaderCellDef>No.</th>
                    <td (click)="getUserr(elementt.id)" mat-cell *matCellDef="let elementt" [ngClass]="{
                        highlight: selectedRowIndex2 == elementt.id
                      }" (click)="getItemDetails2(elementt)">
                      <b class="colorTable"> Name: {{ elementt?.name }} </b> <br />
                      ID.{{ elementt?.id }} <br />

                      DeviceID.{{ elementt?.device_id }}
                    </td>
                  </ng-container>

                  <tr class="d-none" mat-header-row *matHeaderRowDef="displayedColumnst"></tr>
                  <tr mat-row *matRowDef="let elementt; columns: displayedColumnst"></tr>
                </table>

                <mat-paginator #secondPaginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>

                <mat-option class="d-none"> </mat-option>
              </mat-autocomplete>
            </mat-form-field>
          </form>
        </div>

        <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6 w-100  pl-0">
          <div class="p-1 mb-2 containerSize"
            style="background: #323d415c;box-shadow: 5.9px 6.8px 15.5px rgba(137, 148, 169, 0.28), -2.8px -2.8px 8px white, inset 3.5px 3.5px 6px rgba(255, 255, 255, 0.15);border-radius: 6px">
            <div class="col-3 col-md-12 w-100"
              [ngClass]="{'disabled':dataSource?.data.length ===0 ||  spinnerActive != false || getdt ==null }">
              <div class="row">

                <div class="col-6 col-md-2 w-100">
                  <div style="
                cursor: pointer;
                border-radius: 7px;

                display: flex;
                justify-content: center;

              " class="py-1">
                    <img (click)="exportDeviceTable(exportDirective, 'xlsx')"
                      src="https://img.icons8.com/color/48/000000/export-excel.png" />


                  </div>
                </div>
                <div class="col-6 col-md-3 w-100">
                  <div style="
                cursor: pointer;
                border-radius: 7px;

                display: flex;
                justify-content: center;

              " class="py-1">
                    <img (click)="exportDeviceTable(exportDirective, 'csv')"
                      src="https://img.icons8.com/color/48/000000/export-csv.png" />

                  </div>
                </div>
                <div class="col-6 col-md-2 w-100">
                  <div style="
                cursor: pointer;
                border-radius: 7px;

                display: flex;
                justify-content: center;

              " class="py-1">
                    <img (click)="exportDeviceTable(exportDirective, 'json')"
                      src="https://img.icons8.com/color/50/000000/json-download.png" />

                  </div>
                </div>
                <div class="col-6 col-md-3 w-100">
                  <div style="
                cursor: pointer;
                border-radius: 7px;

                display: flex;
                justify-content: center;

              " class="py-1">

                    <img (click)="exportDeviceTable(exportDirective, 'txt')"
                      src="https://img.icons8.com/color/50/000000/rich-text-converter.png" />
                  </div>
                </div>
                <div class="col-6 col-md-2 w-100">
                  <div style="
                cursor: pointer;
                border-radius: 7px;

                display: flex;
                justify-content: center;

              " class="py-1">
                    <img (click)="exportDeviceTablePDF()" src="https://img.icons8.com/color/48/000000/export-pdf.png" />

                  </div>
                </div>

              </div>


            </div>

          </div>
        </div>

        <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6 w-100  ">
          <div class="p-3   containerSize"
            style="background: #323d415c;box-shadow: 5.9px 6.8px 15.5px rgba(137, 148, 169, 0.28), -2.8px -2.8px 8px white, inset 3.5px 3.5px 6px rgba(255, 255, 255, 0.15);border-radius: 6px">
            <mat-chip-list [ngClass]="{'disabled': spinnerActive != false || getdt ==null  }"
              [disabled]=" spinnerActive != false || getdt ==null   ? 'disabled' : null">
              <mat-chip style="background: #1f1f20; color: #ffffff" selected (click)="FilterPeriode(1)">1 jour
              </mat-chip>
              <mat-chip selected style="background: #fdd512; color: #ffffff" (click)="FilterPeriode(7)">7 jours
              </mat-chip>
              <mat-chip selected style="background: #237dbd; color: #ffffff" (click)="FilterPeriode(30)">1 mois
              </mat-chip>

              <mat-chip color="accent" selected (click)="FilterPeriode(60)">2 mois</mat-chip>

              <mat-chip selected style="background: #28a745; color: #ffffff" selected (click)="FilterPeriode(180)">6
                mois
              </mat-chip>
              <mat-chip color="primary" selected (click)="FilterPeriode(365)">1 année</mat-chip>
            </mat-chip-list>
          </div>

        </div>

      </div> -->
      <div class="row">
        <div class="col-12 col-md-12 w-100">
          <p class="message">Messages entrants</p>
          <div class="mat-elevation-z8 tablee" [ngClass]="{hiddenContenuTbls: tblhidden == 'true' ,
                        hiddenContenuTbls2 : tblhidden != 'true' }">
            <form>
              <ngx-spinner *ngIf="spinnerActive != false" bdColor="rgba(100,112,124,0.56)" size="medium"
                           color="#233547" type="ball-clip-rotate-multiple" [fullScreen]="false" [zIndex]="999">
                <p style="color: white"></p>
              </ngx-spinner>

              <!-- <ng-template class="message" matStepLabel >Messages entrants</ng-template> -->

              <div class="example-container  mat-elevation-z8">

                <table id="ExampleTable" #exportDirective="matTableExporter" matTableExporter mat-table
                       [dataSource]="dataSource" matSort>
                  <ng-container matColumnDef="id">
                    <th mat-header-cell mat-sort-header *matHeaderCellDef>
                      ID.
                    </th>
                    <td mat-cell *matCellDef="let row" [ngClass]="{ highlight: selectedRowIndex == row?.id }"
                        (click)="getItemDetails(row)">
                      {{ row?.id }}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="unit_id">
                    <th mat-header-cell mat-sort-header *matHeaderCellDef>
                      ID.Véhicule
                    </th>
                    <td mat-cell *matCellDef="let row" [ngClass]="{ highlight: selectedRowIndex == row?.id }"
                        (click)="getItemDetails(row)">
                      {{ row?.unit_id }}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="unitId">
                    <th mat-header-cell mat-sort-header *matHeaderCellDef>
                      ID.Boîtier
                    </th>
                    <td mat-cell *matCellDef="let row" [ngClass]="{ highlight: selectedRowIndex == row?.id }"
                        (click)="getItemDetails(row)">
                      {{ row?.cello_iq_header?.unitId }}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="key">
                    <th mat-header-cell mat-sort-header *matHeaderCellDef>
                      Modules
                    </th>
                    <td mat-cell *matCellDef="let row" [ngClass]="{ highlight: selectedRowIndex == row?.id }"
                        (click)="getItemDetails(row)">
                      <div *ngFor="let item of row?.modules | keyvalue">
                        <b class="colorTable"> {{item.value}} </b> <br>
                      </div>
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="reason">
                    <th mat-header-cell mat-sort-header *matHeaderCellDef>
                      Raison
                    </th>
                    <td mat-cell *matCellDef="let row" [ngClass]="{ highlight: selectedRowIndex == row?.id }"
                        (click)="getItemDetails(row)">
                      {{ row?.reason }}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="sub_reason">
                    <th mat-header-cell mat-sort-header *matHeaderCellDef>
                      Sous raison
                    </th>
                    <td mat-cell *matCellDef="let row" [ngClass]="{ highlight: selectedRowIndex == row?.id }"
                        (click)="getItemDetails(row)">
                      {{ row?.sub_reason }}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="trip_id">
                    <th mat-header-cell mat-sort-header *matHeaderCellDef>
                      ID.Trajet
                    </th>
                    <td mat-cell *matCellDef="let row" [ngClass]="{ highlight: selectedRowIndex == row?.id }"
                        (click)="getItemDetails(row)">
                      {{ row?.trip_id }}
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="maneuver_id">
                    <th mat-header-cell mat-sort-header *matHeaderCellDef>
                      ID.Manoeuvre
                    </th>
                    <td mat-cell *matCellDef="let row" [ngClass]="{ highlight: selectedRowIndex == row?.id }"
                        (click)="getItemDetails(row)">
                      {{ row?.maneuver_id }}
                    </td>
                  </ng-container>


                  <ng-container matColumnDef="timestamp">
                    <th mat-header-cell mat-sort-header *matHeaderCellDef>
                      Timestamp
                    </th>
                    <td mat-cell *matCellDef="let row" [ngClass]="{ highlight: selectedRowIndex == row?.id }"
                        (click)="getItemDetails(row)">
                      {{ row?.timestamp }}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="Latitude">
                    <th mat-header-cell mat-sort-header *matHeaderCellDef>
                      Latitude
                    </th>
                    <td mat-cell *matCellDef="let row" [ngClass]="{ highlight: selectedRowIndex == row?.id }"
                        (click)="getItemDetails(row)">
                      <div class="d-flex" style="align-items: center;">
                        <mat-icon> location_on</mat-icon>
                        {{ row?.gps_stamp?.Latitude }}</div>
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="Longitude">
                    <th mat-header-cell mat-sort-header *matHeaderCellDef>
                      Longitude
                    </th>
                    <td mat-cell *matCellDef="let row" [ngClass]="{ highlight: selectedRowIndex == row?.id }"
                        (click)="getItemDetails(row)">
                      <div class="d-flex" style="align-items: center;">
                        <mat-icon> location_on</mat-icon>
                        {{ row?.gps_stamp?.Longitude }} </div>
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="Satellites">
                    <th mat-header-cell mat-sort-header *matHeaderCellDef>
                      Satelite
                    </th>
                    <td mat-cell *matCellDef="let row" [ngClass]="{ highlight: selectedRowIndex == row?.id }"
                        (click)="getItemDetails(row)">
                      {{ row?.gps_stamp?.Satellites }}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="Direction">
                    <th mat-header-cell mat-sort-header *matHeaderCellDef>
                      Direction
                    </th>
                    <td mat-cell *matCellDef="let row" [ngClass]="{ highlight: selectedRowIndex == row?.id }"
                        (click)="getItemDetails(row)">
                      <div class="d-flex" style="align-items: center;">
                        <mat-icon> directions</mat-icon>
                        {{ row?.gps_stamp?.Direction }} </div>
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="Speed">
                    <th mat-header-cell mat-sort-header *matHeaderCellDef>
                      Vitesse
                    </th>
                    <td mat-cell *matCellDef="let row" [ngClass]="{ highlight: selectedRowIndex == row?.id }"
                        (click)="getItemDetails(row)">
                      <div class="d-flex" style="align-items: center;">
                        <mat-icon>shutter_speed</mat-icon>
                        {{ row?.gps_stamp?.Speed }} </div>
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="data_brute">
                    <th style="display: none;visibility: hidden;" mat-header-cell mat-sort-header *matHeaderCellDef>
                      data_brute
                    </th>
                    <td style="display: none;visibility: hidden;" mat-cell *matCellDef="let row"
                        [ngClass]="{ highlight: selectedRowIndex == row?.id }" (click)="getItemDetails(row)">
                      {{ row?.trame_brut }}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="created_at">
                    <th mat-header-cell mat-sort-header *matHeaderCellDef style="min-width: 265px;">
                      Date de réception
                    </th>
                    <td mat-cell *matCellDef="let row" [ngClass]="{ highlight: selectedRowIndex == row?.id }"
                        (click)="getItemDetails(row)">
                      <p class="m-0" placement="left" ngbTooltip="Date de création"><img
                        src="https://img.icons8.com/cotton/18/000000/create-new--v3.png"/> {{ row?.created_at  }} </p>
                      <p class="m-0" placement="left" ngbTooltip="Date de mise à jour"><img
                        src="https://img.icons8.com/cotton/18/000000/loop.png"/> {{ row?.updated_at  }}</p>

                    </td>
                  </ng-container>
                  <ng-container matColumnDef="updated_at">
                    <th style="display: none;" mat-header-cell mat-sort-header *matHeaderCellDef>
                      Date de modification
                    </th>
                    <td style="display: none;" mat-cell *matCellDef="let row"
                        [ngClass]="{ highlight: selectedRowIndex == row?.id }" (click)="getItemDetails(row)">
                      {{ row?.updated_at | date:"dd/MM/yyyy hh:mm" }}
                    </td>
                  </ng-container>
                  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                  <tr style="cursor: pointer;" (dblclick)="getDataModulesTramesSelected(row?.id,nom)" mat-row
                      *matRowDef="let row; columns: displayedColumns"></tr>
                  <tr class="mat-row" *matNoDataRow>
                    <td class="mat-cell" colspan="20">
                      Aucune donnée

                    </td>
                  </tr>
                </table>
              </div>
              <mat-paginator #paginator [pageSize]="15" (page)="pageChanged($event)"
                             [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons>
              </mat-paginator>
            </form>
            <!-- <mat-vertical-stepper  #stepper>
              <mat-step>
              </mat-step>
              <mat-step>
                <form>
                  <ng-template matStepLabel> Messages sortants</ng-template>
                </form>
              </mat-step>
            </mat-vertical-stepper> -->
          </div>
          <!-- <p class="message">Messages sortants</p> -->
        </div>
      </div>
    </div>
  </div>
</div>
<ng-template #nom>
  <div class="container" style="margin-left: 1%;">
    <div class=" row">
      <div class="col-5" style="margin-top:-2%;    border-right: 1px solid #d5d5d5;">
        <p style="    margin-top: 31px;" class="message-2">Informations Boîtiers</p>
        <div class="row">
          <div *ngIf="getdt !=null" class="row p-3">
            <div class="col-2">
              <b style="color: #262756;">ID boîtier</b>
              <br><br>
              <b style="color: #262756;">Téléphone</b>
              <br><br>
              <b style="color: #262756;">Type</b>
              <br><br>
              <b style="color: #262756;">Dernier message</b>
              <br><br>
              <b style="color: #262756;" class="clickPointer" placement="bottom"
                 ngbTooltip="Cliquez pour afficher le statut de calibration"
                 (click)="openDialogFileUpload()"> Statut calibration <i
                class="fa fa-battery-full BoitierCalibration"></i> </b>
              <br> <br>
              <b style="color: #262756;">Boîtier connecté <span *ngIf="is_online ==0" class="pulse"></span> <span
                *ngIf="is_online !=0"
                class="pulseActive"></span></b>
              <br><br><b style="color: #262756;">Véhicule</b>
              <br><br>
              <b style="color: #262756;">Compagnie</b>
              <br><br>
              <b style="color: #262756;">Revendeur</b>
              <br><br>
              <b style="color: #262756;">Intégrateur</b>

            </div>
            <div class="col-2 offset-2 text-right wrapper">
              <p class="message-code">{{device_id}} </p>
              <p class="message-code"></p>
              <p class="message-code"></p>
              <p class="message-code"></p>
              <p class="message-code"></p>
              <p class="message-code" style="margin-top: 211%;"> {{device_name}} </p>
              <p class="message-code">{{company_name}}</p>
              <p class="message-code"></p>
              <p class="message-code"></p>
              <p>{{ itemSelect.name }}</p>
            </div>
          </div>
          <!-- <div *ngIf="getdt !=null" class="dropdown-divider"></div> -->
        </div>

      </div>
      <div class="col-5 offset-1">
        <div class="row pr-3 py-3">
          <div *ngIf="itemSelect.cello_iq_header?.startBlock !=null"
               class="col-6"
               style="margin-top: -2%;">
            <p class="message-2"> Données brute </p>
            <div
              *ngIf="hiddenDetails !=false  && tblhidden != 'true'" class="row" style="cursor:pointer;width: 231%;">
              <div class="col-6" style=" margin-top: -2%; max-width:100%; word-wrap:break-word;">
                {{ itemSelect.trame_brut }}
              </div>

            </div>
          </div>
        </div>

      </div>
    </div>
    <div class="row"
         style="position: absolute;
    margin-top: -34%;
    margin-left: 44%;">
      <div class="col-6">
        <div>
          <div *ngIf="itemSelect.cello_iq_header?.startBlock !=null" class="row mb-2 pt-4"
               style=" display: flex;align-items: center;">
            <div class="col-md-7 px-0 w-100" style="margin-top: -4%;">
              <p class="message-2" style="margin-left: 25%;">Gestion des Modules </p>
            </div>
          </div>
          <div class="col p-0" style="  border-radius: 6px; margin-top: -1%;">
            <div class="mr-2">
              <div class="col-12">
                <div class="row p-3">
                  <div class="col-5 ">
                    <b style="color: #262756;">startBlock</b>
                    <br><br>
                    <b style="color: #262756;">messageLength</b>
                    <br><br>
                    <b style="color: #262756;">messageId</b>
                    <br><br>
                    <b style="color: #262756;">protocolVersion</b>
                    <br><br>
                    <b style="color: #262756;">messageType</b>
                    <br><br>
                    <b style="color: #262756;">direction</b>
                    <br><br>
                    <b style="color: #262756;">initiator</b>
                    <br><br>
                    <b style="color: #262756;">unitId</b>
                  </div>
                  <div class="col-5 offset-2 text-right wrapper"
                       style="margin-top: -238%; margin-left: 109%;">
                    <p style="margin-top: 17%;" class="message-code">{{ itemSelect.cello_iq_header?.startBlock }}</p>
                    <p style="margin-top: 17%;" style="margin-top: 17%;"
                       class="message-code">{{ itemSelect.cello_iq_header?.messageLength }}</p>
                    <p style="margin-top: 17%;" class="message-code">{{ itemSelect.cello_iq_header?.messageId }}</p>
                    <p style="margin-top: 17%;"
                       class="message-code">{{ itemSelect.cello_iq_header?.protocolVersion }}</p>
                    <p style="margin-top: 17%;" class="message-code">{{ itemSelect.cello_iq_header?.messageType }}</p>
                    <p style="margin-top: 17%;" class="message-code">{{ itemSelect.cello_iq_header?.direction }}</p>
                    <p style="margin-top: 17%;" class="message-code">{{ itemSelect.cello_iq_header?.initiator }}</p>
                    <p style="margin-top: 17%;" class="message-code">{{ itemSelect.cello_iq_header?.unitId }}</p>
                  </div>
                </div>
              </div>
            </div>

          </div>
          <!--CelloIQHeader Module-->
          <div *ngIf="itemSelect !=null" class="row rowposition2 pr-3">
            <!--OverSpeedManeuverStatistics Module-->

            <div *ngIf=" itemSelectresp.modules?.OverSpeedManeuverStatistics?.trip_id !=null" class="col p-0"
                 style="  border-radius: 6px">
              <div class="mr-2"
                   style="    box-shadow: 5.9px 6.8px 15.5px rgba(137, 148, 169, 0.28), -2.8px -2.8px 8px white, inset 3.5px 3.5px 6px rgba(255, 255, 255, 0.15);">
                <ul class="list-group ">
                  <li class="list-group-item active" style="color: #ffffff">
                    OverSpeedManeuverStatistics
                  </li>
                </ul>
                <div *ngIf="hiddenDetails !=false  && tblhidden != 'true'"
                     class="col-12 col-md-3 w-100 my-3  px-2 py-0 "
                     style="max-width:100%; word-wrap:break-word;background: #FFFFFF">
                  <div class="row px-2 ">

                    <table class="table table-hover w-100" style="border-style: hidden;">
                      <thead class="d-none">
                      <tr class="d-none">
                        <th scope="col">Last</th>
                        <th scope="col">Handle</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr>
                        <td><b>tripId</b></td>
                        <td style="max-width:20px; word-wrap:break-word;">
                          {{ itemSelectresp.modules?.OverSpeedManeuverStatistics.trip_id }} </td>
                      </tr>
                      <tr>
                        <td><b>maneuverId</b></td>
                        <td style="max-width:20px; word-wrap:break-word;">
                          {{ itemSelectresp.modules?.OverSpeedManeuverStatistics.maneuver_id }} </td>
                      </tr>

                      <tr>
                        <td><b>maneuverType</b></td>
                        <td style="max-width:20px; word-wrap:break-word;">
                          {{ itemSelectresp.modules?.OverSpeedManeuverStatistics.maneuver_type }}</td>
                      </tr>
                      <tr>
                        <td><b>maneuverDuration</b></td>
                        <td style="max-width:20px; word-wrap:break-word;">
                          {{ itemSelectresp.modules?.OverSpeedManeuverStatistics.maneuver_duration }} </td>

                      </tr>
                      <tr>
                        <td><b>speedaverage</b></td>
                        <td style="max-width:20px; word-wrap:break-word;">
                          {{ itemSelectresp.modules?.OverSpeedManeuverStatistics.speed_average }} </td>

                      </tr>
                      <tr>
                        <td><b>speedMax</b></td>
                        <td style="max-width:20px; word-wrap:break-word;">
                          {{ itemSelectresp.modules?.OverSpeedManeuverStatistics.speed_max }} </td>
                      </tr>
                      <tr>
                        <td><b>speedDelta</b></td>
                        <td style="max-width:20px; word-wrap:break-word;">
                          {{ itemSelectresp.modules?.OverSpeedManeuverStatistics.speed_delta }} </td>
                      </tr>
                      <tr>
                        <td><b>maneuverSeverity</b></td>
                        <td style="max-width:20px; word-wrap:break-word;">
                          {{ itemSelectresp.modules?.OverSpeedManeuverStatistics.maneuver_severity }} </td>
                      </tr>
                      <tr>
                        <td><b>riskScore</b></td>
                        <td style="max-width:20px; word-wrap:break-word;">
                          {{ itemSelectresp.modules?.OverSpeedManeuverStatistics.risk_score }} </td>
                      </tr>
                      <tr>
                        <td><b>trameId</b></td>
                        <td style="max-width:20px; word-wrap:break-word;">
                          {{ itemSelectresp.modules?.OverSpeedManeuverStatistics.trame_id }} </td>
                      </tr>

                      <tr>
                        <td><b>startLocation</b></td>

                        <td style="max-width:20px; word-wrap:break-word;">

                          <div
                            *ngFor="let item of itemSelect.modules?.OverSpeedManeuverStatistics.start_location | keyvalue">
                            <p>{{item.key}} : {{item.value}} <br></p>
                          </div>


                        </td>
                      </tr>
                      <tr>
                        <td><b>endLocation</b></td>

                        <td style="max-width:20px; word-wrap:break-word;">

                          <div
                            *ngFor="let item of itemSelectresp.modules?.OverSpeedManeuverStatistics.end_location | keyvalue">
                            <p>{{item.key}} : {{item.value}} <br></p>
                          </div>


                        </td>

                      </tr>
                      <tr>
                        <td><b>startTime</b></td>

                        <td style="max-width:20px; word-wrap:break-word;">

                          <div
                            *ngFor="let item of itemSelectresp.modules?.OverSpeedManeuverStatistics.start_time | keyvalue">
                            <p>{{item.key}} : {{item.value}} <br></p>
                          </div>


                        </td>
                      </tr>


                      </tbody>
                    </table>
                  </div>
                </div>

              </div>
            </div>

            <!--EDRCrashAttributes Module-->

            <div *ngIf=" itemSelectresp.modules?.EDRCrashAttributes?.crash_id !=null" class="col p-0"
                 style="  border-radius: 6px">
              <div class="mr-2"
                   style="    box-shadow: 5.9px 6.8px 15.5px rgba(137, 148, 169, 0.28), -2.8px -2.8px 8px white, inset 3.5px 3.5px 6px rgba(255, 255, 255, 0.15);">
                <ul class="list-group ">
                  <li class="list-group-item active" style="color: #ffffff">
                    EDRCrashAttributes
                  </li>
                </ul>
                <div *ngIf="hiddenDetails !=false  && tblhidden != 'true'"
                     class="col-12 col-md-3 w-100 my-3  px-2 py-0 "
                     style="max-width:100%; word-wrap:break-word;background: #FFFFFF">
                  <div class="row px-2 ">

                    <table class="table table-hover w-100" style="border-style: hidden;">
                      <thead class="d-none">
                      <tr class="d-none">
                        <th scope="col">Last</th>
                        <th scope="col">Handle</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr>
                        <td><b>crashId</b></td>
                        <td style="max-width:20px; word-wrap:break-word;">
                          {{ itemSelectresp.modules?.EDRCrashAttributes.crash_id }} </td>
                      </tr>
                      <tr>
                        <td><b>vehicleType</b></td>
                        <td style="max-width:20px; word-wrap:break-word;">
                          {{ itemSelectresp.modules?.EDRCrashAttributes.vehicle_type }} </td>
                      </tr>

                      <tr>
                        <td><b>crashType</b></td>
                        <td style="max-width:20px; word-wrap:break-word;">
                          {{ itemSelectresp.modules?.EDRCrashAttributes.crash_type }}</td>
                      </tr>
                      <tr>
                        <td><b>maxG</b></td>
                        <td
                          style="max-width:20px; word-wrap:break-word;">{{ itemSelectresp.modules?.EDRCrashAttributes.maxG
                          }}
                        </td>

                      </tr>


                      <tr>
                        <td><b>orientation</b></td>
                        <td style="max-width:20px; word-wrap:break-word;">
                          {{ itemSelectresp.modules?.EDRCrashAttributes.orientation }} </td>

                      </tr>
                      <tr>
                        <td><b>roll</b></td>
                        <td
                          style="max-width:20px; word-wrap:break-word;">{{ itemSelectresp.modules?.EDRCrashAttributes.roll
                          }}
                        </td>
                      </tr>
                      <tr>
                        <td><b>parking</b></td>
                        <td style="max-width:20px; word-wrap:break-word;">{{
                          itemSelectresp.modules?.EDRCrashAttributes.parking }}
                        </td>
                      </tr>
                      <tr>
                        <td><b>durationInSeconds</b></td>
                        <td style="max-width:20px; word-wrap:break-word;">
                          {{ itemSelectresp.modules?.EDRCrashAttributes.duration_in_seconds }} </td>
                      </tr>
                      <tr>
                        <td><b>numInitaccel</b></td>
                        <td style="max-width:20px; word-wrap:break-word;">
                          {{ itemSelectresp.modules?.EDRCrashAttributes.num_init_accel }} </td>
                      </tr>
                      <tr>
                        <td><b>amountPostSamples</b></td>
                        <td style="max-width:20px; word-wrap:break-word;">
                          {{ itemSelectresp.modules?.EDRCrashAttributes.amount_post_samples }} </td>
                      </tr>

                      <tr>
                        <td><b>preDataLenSec</b></td>
                        <td style="max-width:20px; word-wrap:break-word;">
                          {{ itemSelectresp.modules?.EDRCrashAttributes.pre_data_len_sec }} </td>
                      </tr>
                      <tr>
                        <td><b>postDataLenSec</b></td>
                        <td style="max-width:20px; word-wrap:break-word;">
                          {{ itemSelectresp.modules?.EDRCrashAttributes.post_data_len_sec }} </td>
                      </tr>
                      <tr>
                        <td><b>trameId</b></td>
                        <td style="max-width:20px; word-wrap:break-word;">
                          {{ itemSelectresp.modules?.EDRCrashAttributes.trame_id }} </td>
                      </tr>


                      </tbody>
                    </table>
                  </div>
                </div>

              </div>
            </div>
            <!--CSAFullEvent Module-->

            <div *ngIf="itemSelectresp.modules?.CSAFullEvent?.driver_id !=null" class="col p-0"
                 style="  border-radius: 6px">
              <div class="mr-2"
                   style="    box-shadow: 5.9px 6.8px 15.5px rgba(137, 148, 169, 0.28), -2.8px -2.8px 8px white, inset 3.5px 3.5px 6px rgba(255, 255, 255, 0.15);">
                <ul class="list-group ">
                  <li class="list-group-item active" style="color: #ffffff">
                    CSAFullEvent
                  </li>
                </ul>
                <div *ngIf="hiddenDetails !=false  && tblhidden != 'true'"
                     class="col-12 col-md-3 w-100 my-3  px-2 py-0 "
                     style="max-width:100%; word-wrap:break-word;background: #FFFFFF">
                  <div class="row px-2 ">

                    <table class="table table-hover w-100" style="border-style: hidden;">
                      <thead class="d-none">
                      <tr class="d-none">
                        <th scope="col">Last</th>
                        <th scope="col">Handle</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr>
                        <td><b>eventInfo</b></td>
                        <td style=" letter-spacing: 0px; word-wrap:break-word;">
                          <p> Reason:{{ itemSelectresp.modules?.CSAFullEvent?.reason }} </p>
                          <p> Sub_reason:{{ itemSelectresp.modules?.CSAFullEvent?.sub_reason }}</p>
                          <p> event_numerator:{{ itemSelectresp.modules?.CSAFullEvent?.event_numerator }}</p>

                          <div *ngFor="let item of itemSelectresp.modules?.CSAFullEvent?.operational_mode | keyvalue">
                            <p> {{item.key}}: {{item.value}} <br></p>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td><b>driverId</b></td>
                        <td style=" letter-spacing: 0px; word-wrap:break-word;">
                          {{ itemSelectresp.modules?.CSAFullEvent?.dallas }} </td>
                      </tr>
                      <tr>
                        <td><b>tripId</b></td>
                        <td
                          style="max-width:20px; word-wrap:break-word;">{{ itemSelectresp.modules?.CSAFullEvent?.trip_id }}
                        </td>
                      </tr>
                      <tr>
                        <td><b>maneuverId</b></td>
                        <td
                          style="max-width:20px; word-wrap:break-word;">{{ itemSelectresp.modules?.CSAFullEvent?.maneuver_id
                          }}
                        </td>
                      </tr>
                      <tr>
                        <td><b>memoryUsageStatus</b></td>
                        <td style=" letter-spacing: 0px; word-wrap:break-word;">

                          <div
                            *ngFor="let item of itemSelectresp.modules?.CSAFullEvent?.memory_usage_status | keyvalue">
                            <p>{{item.key}} : {{item.value}}</p>
                          </div>
                        </td>
                      </tr>

                      <tr>
                        <td><b>gpsStamp</b></td>
                        <td style=" letter-spacing: 0px; word-wrap:break-word;">
                          <div *ngFor="let item of itemSelectresp.modules?.CSAFullEvent?.gps_stamp | keyvalue">
                            <p>{{item.key}} : {{item.value}} <br></p>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td><b>timeStamp</b></td>
                        <td style="max-width:20px; word-wrap:break-word;">

                          <div *ngFor="let item of itemSelectresp.modules?.CSAFullEvent?.timestamp | keyvalue">
                            <p>{{item.key}} : {{item.value}} <br></p>
                          </div>


                        </td>
                      </tr>


                      </tbody>
                    </table>
                  </div>
                </div>

              </div>
            </div>


            <!--TripStatistics Module-->

            <div *ngIf=" itemSelectresp.modules?.TripStatistics?.trip_id !=null" class="col p-0"
                 style="  border-radius: 6px">
              <div class="mr-2"
                   style="    box-shadow: 5.9px 6.8px 15.5px rgba(137, 148, 169, 0.28), -2.8px -2.8px 8px white, inset 3.5px 3.5px 6px rgba(255, 255, 255, 0.15);">
                <ul class="list-group ">
                  <li class="list-group-item active" style="color: #ffffff">
                    TripStatistics
                  </li>
                </ul>
                <div *ngIf="hiddenDetails !=false  && tblhidden != 'true'"
                     class="col-12 col-md-3 w-100 my-3  px-2 py-0 "
                     style="max-width:100%; word-wrap:break-word;background: #FFFFFF">
                  <div class="row px-2 ">

                    <table class="table table-hover w-100" style="border-style: hidden;">
                      <thead class="d-none">
                      <tr class="d-none">
                        <th scope="col">Last</th>
                        <th scope="col">Handle</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr>
                        <td><b>tripId</b></td>
                        <td
                          style="max-width:20px; word-wrap:break-word;">{{ itemSelectresp.modules?.TripStatistics.trip_id }}
                        </td>
                      </tr>
                      <tr>
                        <td><b>driverId</b></td>
                        <td
                          style="max-width:20px; word-wrap:break-word;">{{ itemSelectresp.modules?.TripStatistics.dallas }}
                        </td>
                      </tr>
                      <tr>
                        <td><b>timeStamp</b></td>
                        <td style="max-width:20px; word-wrap:break-word;">

                          <div *ngFor="let item of itemSelectresp.modules?.TripStatistics.timestamp | keyvalue">
                            <p>{{item.key}}: {{item.value}} <br></p>
                          </div>


                        </td>
                      </tr>
                      <tr>
                        <td><b>tripDuration</b></td>
                        <td style="max-width:20px; word-wrap:break-word;">
                          {{ itemSelectresp.modules?.TripStatistics.trip_duration }}</td>
                      </tr>
                      <tr>
                        <td><b>distanceTraveled</b></td>
                        <td style="max-width:20px; word-wrap:break-word;">
                          {{ itemSelectresp.modules?.TripStatistics.distance_traveled }} </td>

                      </tr>


                      <tr>
                        <td><b>movementTime</b></td>
                        <td style="max-width:20px; word-wrap:break-word;">
                          {{ itemSelectresp.modules?.TripStatistics.movement_time }} </td>

                      </tr>
                      <tr>
                        <td><b>shortIdleTime</b></td>
                        <td style="max-width:20px; word-wrap:break-word;">
                          {{ itemSelectresp.modules?.TripStatistics.short_idle_time }} </td>
                      </tr>
                      <tr>
                        <td><b>longIdleTime</b></td>
                        <td style="max-width:20px; word-wrap:break-word;">
                          {{ itemSelectresp.modules?.TripStatistics.long_idle_time }} </td>
                      </tr>
                      <tr>
                        <td><b>maxSpeed</b></td>
                        <td
                          style="max-width:20px; word-wrap:break-word;">{{ itemSelectresp.modules?.TripStatistics.max_speed
                          }}
                        </td>
                      </tr>
                      <tr>
                        <td><b>avgSpeed</b></td>
                        <td
                          style="max-width:20px; word-wrap:break-word;">{{ itemSelectresp.modules?.TripStatistics.avg_speed
                          }}
                        </td>
                      </tr>
                      <tr>
                        <td><b>weightedSafetyScore</b></td>
                        <td style="max-width:20px; word-wrap:break-word;">
                          {{ itemSelectresp.modules?.TripStatistics.weighted_safety_score }} </td>
                      </tr>

                      <tr>
                        <td><b>weightedEcoScore</b></td>
                        <td style="max-width:20px; word-wrap:break-word;">
                          {{ itemSelectresp.modules?.TripStatistics.weighted_eco_score }} </td>
                      </tr>
                      <tr>
                        <td><b>idleScore</b></td>
                        <td
                          style="max-width:20px; word-wrap:break-word;">{{ itemSelectresp.modules?.TripStatistics.idle_score
                          }}
                        </td>
                      </tr>
                      <tr>
                        <td><b>trameId</b></td>
                        <td
                          style="max-width:20px; word-wrap:break-word;">{{ itemSelectresp.modules?.TripStatistics.trame_id
                          }}
                        </td>
                      </tr>


                      </tbody>
                    </table>
                  </div>
                </div>

              </div>
            </div>

            <!--IdlingContinuousManeuverStatistics Module-->


            <div *ngIf=" itemSelectresp.modules?.IdlingContinuousManeuverStatistics?.trip_id !=null" class="col p-0"
                 style="  border-radius: 6px">
              <div class="mr-2"
                   style="    box-shadow: 5.9px 6.8px 15.5px rgba(137, 148, 169, 0.28), -2.8px -2.8px 8px white, inset 3.5px 3.5px 6px rgba(255, 255, 255, 0.15);">
                <ul class="list-group ">
                  <li class="list-group-item active" style="color: #ffffff">
                    IdlingContinuousManeuverStatistics
                  </li>
                </ul>
                <div *ngIf="hiddenDetails !=false  && tblhidden != 'true'"
                     class="col-12 col-md-3 w-100 my-3  px-2 py-0 "
                     style="max-width:100%; word-wrap:break-word;background: #FFFFFF">
                  <div class="row px-2 ">

                    <table class="table table-hover w-100" style="border-style: hidden;">
                      <thead class="d-none">
                      <tr class="d-none">
                        <th scope="col">Last</th>
                        <th scope="col">Handle</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr>
                        <td><b>tripId</b></td>
                        <td style="max-width:20px; word-wrap:break-word;">
                          {{ itemSelectresp.modules?.IdlingContinuousManeuverStatistics.trip_id }} </td>
                      </tr>
                      <tr>
                        <td><b>maneuverId</b></td>
                        <td style="max-width:20px; word-wrap:break-word;">
                          {{ itemSelectresp.modules?.IdlingContinuousManeuverStatistics.maneuver_id }} </td>
                      </tr>

                      <tr>
                        <td><b>maneuverType</b></td>
                        <td style="max-width:20px; word-wrap:break-word;">
                          {{ itemSelectresp.modules?.IdlingContinuousManeuverStatistics.maneuver_type }}</td>
                      </tr>
                      <tr>
                        <td><b>maneuverDuration</b></td>
                        <td style="max-width:20px; word-wrap:break-word;">
                          {{ itemSelectresp.modules?.IdlingContinuousManeuverStatistics.maneuver_duration }} </td>

                      </tr>


                      <tr>
                        <td><b>shortIdlingDuration</b></td>
                        <td style="max-width:20px; word-wrap:break-word;">
                          {{ itemSelectresp.modules?.IdlingContinuousManeuverStatistics.short_idling_duration }} </td>

                      </tr>

                      <tr>
                        <td><b>longIdlingDuration</b></td>
                        <td style="max-width:20px; word-wrap:break-word;">
                          {{ itemSelectresp.modules?.IdlingContinuousManeuverStatistics.long_idling_duration }} </td>

                      </tr>
                      <tr>
                        <td><b>idlingValidGpsDuration</b></td>
                        <td style="max-width:20px; word-wrap:break-word;">
                          {{ itemSelectresp.modules?.IdlingContinuousManeuverStatistics.idling_valid_gps_duration }} </td>
                      </tr>
                      <tr>
                        <td><b>idling_accelerometer_duration</b></td>
                        <td style="max-width:20px; word-wrap:break-word;">
                          {{ itemSelectresp.modules?.IdlingContinuousManeuverStatistics.idling_accelerometer_duration }} </td>
                      </tr>
                      <tr>
                        <td><b>engineOnDuration</b></td>
                        <td style="max-width:20px; word-wrap:break-word;">
                          {{ itemSelectresp.modules?.IdlingContinuousManeuverStatistics.engine_on_duration }} </td>
                      </tr>
                      <tr>
                        <td><b>ignitionOnDuration</b></td>
                        <td style="max-width:20px; word-wrap:break-word;">
                          {{ itemSelectresp.modules?.IdlingContinuousManeuverStatistics.ignition_on_duration }} </td>
                      </tr>
                      <tr>
                        <td><b>trameId</b></td>
                        <td style="max-width:20px; word-wrap:break-word;">
                          {{ itemSelectresp.modules?.IdlingContinuousManeuverStatistics.trame_id }} </td>
                      </tr>

                      <tr>
                        <td><b>startLocation</b></td>

                        <td style="max-width:20px; word-wrap:break-word;">

                          <div
                            *ngFor="let item of itemSelectresp.modules?.IdlingContinuousManeuverStatistics.start_location | keyvalue">
                            <p>{{item.key}} : {{item.value}} <br></p>
                          </div>


                        </td>
                      </tr>
                      <tr>
                        <td><b>endLocation</b></td>

                        <td style="max-width:20px; word-wrap:break-word;">

                          <div
                            *ngFor="let item of itemSelectresp.modules?.IdlingContinuousManeuverStatistics.end_location | keyvalue">
                            <p>{{item.key}} : {{item.value}} <br></p>
                          </div>


                        </td>

                      </tr>
                      <tr>
                        <td><b>startTime</b></td>

                        <td style="max-width:20px; word-wrap:break-word;">

                          <div
                            *ngFor="let item of itemSelectresp.modules?.IdlingContinuousManeuverStatistics.start_time | keyvalue">
                            <p>{{item.key}} : {{item.value}} <br></p>
                          </div>


                        </td>
                      </tr>


                      </tbody>
                    </table>
                  </div>
                </div>

              </div>
            </div>

            <!--OffRoadContinuousManeuverStatistics Module-->

            <div *ngIf=" itemSelectresp.modules?.OffRoadContinuousManeuverStatistics?.trip_id !=null" class="col p-0"
                 style="  border-radius: 6px">
              <div class="mr-2"
                   style="    box-shadow: 5.9px 6.8px 15.5px rgba(137, 148, 169, 0.28), -2.8px -2.8px 8px white, inset 3.5px 3.5px 6px rgba(255, 255, 255, 0.15);">
                <ul class="list-group ">
                  <li class="list-group-item active" style="color: #ffffff">
                    OffRoadContinuousManeuverStatistics
                  </li>
                </ul>
                <div *ngIf="hiddenDetails !=false  && tblhidden != 'true'"
                     class="col-12 col-md-3 w-100 my-3  px-2 py-0 "
                     style="max-width:100%; word-wrap:break-word;background: #FFFFFF">
                  <div class="row px-2 ">

                    <table class="table table-hover w-100" style="border-style: hidden;">
                      <thead class="d-none">
                      <tr class="d-none">
                        <th scope="col">Last</th>
                        <th scope="col">Handle</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr>
                        <td><b>tripId</b></td>
                        <td style="max-width:20px; word-wrap:break-word;">
                          {{ itemSelectresp.modules?.OffRoadContinuousManeuverStatistics.trip_id }} </td>
                      </tr>
                      <tr>
                        <td><b>maneuverId</b></td>
                        <td style="max-width:20px; word-wrap:break-word;">
                          {{ itemSelectresp.modules?.OffRoadContinuousManeuverStatistics.maneuver_id }} </td>
                      </tr>

                      <tr>
                        <td><b>maneuverType</b></td>
                        <td style="max-width:20px; word-wrap:break-word;">
                          {{ itemSelectresp.modules?.OffRoadContinuousManeuverStatistics.maneuver_type }}</td>
                      </tr>
                      <tr>
                        <td><b>maneuverDuration</b></td>
                        <td style="max-width:20px; word-wrap:break-word;">
                          {{ itemSelectresp.modules?.OffRoadContinuousManeuverStatistics.maneuver_duration }} </td>

                      </tr>


                      <tr>
                        <td><b>speedaverage</b></td>
                        <td style="max-width:20px; word-wrap:break-word;">
                          {{ itemSelectresp.modules?.OffRoadContinuousManeuverStatistics.speed_average }} </td>
                      </tr>
                      <tr>
                        <td><b>trameId</b></td>
                        <td style="max-width:20px; word-wrap:break-word;">
                          {{ itemSelectresp.modules?.OffRoadContinuousManeuverStatistics.trame_id }} </td>
                      </tr>

                      <tr>
                        <td><b>startLocation</b></td>

                        <td style="max-width:20px; word-wrap:break-word;">

                          <div
                            *ngFor="let item of itemSelectresp.modules?.OffRoadContinuousManeuverStatistics.start_location | keyvalue">
                            <p>{{item.key}} : {{item.value}} <br></p>
                          </div>


                        </td>
                      </tr>
                      <tr>
                        <td><b>endLocation</b></td>

                        <td style="max-width:20px; word-wrap:break-word;">

                          <div
                            *ngFor="let item of itemSelectresp.modules?.OffRoadContinuousManeuverStatistics.end_location | keyvalue">
                            <p>{{item.key}} : {{item.value}} <br></p>
                          </div>


                        </td>

                      </tr>
                      <tr>
                        <td><b>startTime</b></td>

                        <td style=" word-wrap:break-word;">

                          <div
                            *ngFor="let item of itemSelectresp.modules?.OffRoadContinuousManeuverStatistics.start_time | keyvalue">
                            <p>{{item.key}} : {{item.value}} <br></p>
                          </div>


                        </td>
                      </tr>


                      </tbody>
                    </table>
                  </div>
                </div>

              </div>
            </div>
            <!--ABCManeuverStatistics Module-->

            <div *ngIf="itemSelectresp.modules?.ABCManeuverStatistics?.trip_id !=null" class="col  p-0"
                 style="  border-radius: 6px">
              <div class="mr-2"
                   style="    box-shadow: 5.9px 6.8px 15.5px rgba(137, 148, 169, 0.28), -2.8px -2.8px 8px white, inset 3.5px 3.5px 6px rgba(255, 255, 255, 0.15);">
                <ul class="list-group ">
                  <li class="list-group-item active" style="color: #ffffff">
                    ABCManeuverStatistics
                  </li>
                </ul>

                <div *ngIf="hiddenDetails !=false  && tblhidden != 'true'"
                     class="col-12 col-md-3 w-100 my-3  px-2 py-0 "
                     style="max-width:100%; word-wrap:break-word;background: #FFFFFF">
                  <div class="row px-2 ">
                    <table class="table table-hover w-100" style="border-style: hidden;">
                      <thead class="d-none">
                      <tr class="d-none">
                        <th scope="col">Last</th>
                        <th scope="col">Handle</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr>
                        <td><b>tripId</b></td>
                        <td
                          style=" word-wrap:break-word;">{{ itemSelectresp.modules?.ABCManeuverStatistics?.trip_id }}</td>
                      </tr>
                      <tr>
                        <td><b>maneuverId</b></td>
                        <td
                          style=" word-wrap:break-word;">{{ itemSelectresp.modules?.ABCManeuverStatistics?.maneuver_id }}
                        </td>
                      </tr>
                      <tr>
                        <td><b>maneuverType</b></td>
                        <td style="max-width:40px; word-wrap:break-word;">
                          {{ itemSelectresp.modules?.ABCManeuverStatistics?.maneuver_type }}</td>
                      </tr>
                      <tr>
                        <td><b>startLocation</b></td>
                        <td style="max-width:20px; word-wrap:break-word;">

                          Longitude: {{ itemSelectresp.modules?.ABCManeuverStatistics?.start_location.Longitude }}
                          <br>
                          Latitude: {{ itemSelectresp.modules?.ABCManeuverStatistics?.start_location.Latitude }}


                        </td>
                      </tr>
                      <tr>
                        <td><b>endLocation</b></td>
                        <td style="max-width:20px; word-wrap:break-word;">


                          Longitude: {{ itemSelectresp.modules?.ABCManeuverStatistics?.end_location.Longitude }}
                          <br>
                          Latitude: {{ itemSelectresp.modules?.ABCManeuverStatistics?.end_location.Latitude }}


                        </td>
                      </tr>

                      <tr>
                        <td><b>startTime</b></td>
                        <td style="max-width:20px; word-wrap:break-word;">

                          validity: {{ itemSelectresp.modules?.ABCManeuverStatistics?.start_time.validity }}
                          <br>
                          timestamp: {{ itemSelectresp.modules?.ABCManeuverStatistics?.start_time.timestamp }}


                        </td>
                      </tr>
                      <tr>
                        <td><b>maneuverDuration</b></td>
                        <td style="max-width:20px; word-wrap:break-word;">
                          {{ itemSelectresp.modules?.ABCManeuverStatistics?.maneuver_duration }}</td>
                      </tr>
                      <tr>
                        <td><b>speedAverage</b></td>
                        <td style="max-width:20px; word-wrap:break-word;">
                          {{ itemSelectresp.modules?.ABCManeuverStatistics?.speed_average }}</td>
                      </tr>

                      <tr>
                        <td><b>speedMax</b></td>
                        <td style="max-width:20px; word-wrap:break-word;">
                          {{ itemSelectresp.modules?.ABCManeuverStatistics?.speed_max }}</td>
                      </tr>

                      <tr>
                        <td><b>riskScore</b></td>
                        <td style="max-width:20px; word-wrap:break-word;">
                          {{ itemSelectresp.modules?.ABCManeuverStatistics?.risk_score }}</td>
                      </tr>

                      <tr>
                        <td><b>numOfInitFrame</b></td>
                        <td style="max-width:20px; word-wrap:break-word;">
                          {{ itemSelectresp.modules?.ABCManeuverStatistics?.num_init_frame }}</td>
                      </tr>


                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            <!--CSAFirmwareID Module-->

            <div *ngIf=" itemSelectresp.modules?.CSAFirmwareID?.cello_iq_version !=null" class="col  p-0"
                 style="  border-radius: 6px">
              <div
                style="    box-shadow: 5.9px 6.8px 15.5px rgba(137, 148, 169, 0.28), -2.8px -2.8px 8px white, inset 3.5px 3.5px 6px rgba(255, 255, 255, 0.15);">
                <ul class="list-group ">
                  <li class="list-group-item active" style="color: #ffffff">
                    CSAFirmwareID
                  </li>
                </ul>
                <div *ngIf="hiddenDetails !=false  && tblhidden != 'true'" class="col-12 col-md-3 w-100 my-3  p-2 "
                     style="max-width:100%; word-wrap:break-word;background: #FFFFFF">

                  <div class="row px-2 ">
                    <table class="table table-hover w-100" style="border-style: hidden;">
                      <thead class="d-none">
                      <tr class="d-none">
                        <th scope="col">Last</th>
                        <th scope="col">Handle</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr>
                        <td><b>celloIqVersion</b></td>
                        <td style="max-width:40px; word-wrap:break-word;">
                          {{ itemSelectresp.modules?.CSAFirmwareID?.cello_iq_version }}</td>
                      </tr>
                      <tr>
                        <td><b>protocolId</b></td>
                        <td
                          style=" word-wrap:break-word;">{{ itemSelectresp.modules?.CSAFirmwareID?.cello_iq_version }}</td>
                      </tr>
                      <tr>
                        <td><b>productionId</b></td>
                        <td style="max-width:40px; word-wrap:break-word;">{{
                          itemSelectresp.modules?.CSAFirmwareID?.protocol_id }}
                        </td>
                      </tr>
                      <tr>
                        <td><b>firmwareVersion</b></td>
                        <td style="max-width:20px; word-wrap:break-word;">
                          {{ itemSelectresp.modules?.CSAFirmwareID?.firmware_version }}</td>
                      </tr>
                      <tr>
                        <td><b>firmwareSubversion</b></td>
                        <td style="max-width:20px; word-wrap:break-word;">
                          {{ itemSelectresp.modules?.CSAFirmwareID?.firmware_subversion }}</td>
                      </tr>


                      </tbody>
                    </table>

                  </div>
                </div>

              </div>
            </div>

          </div>
          <!-- fin data de dialog  -->
        </div>
      </div>
    </div>
  </div>
  <!-- data de dialog  -->

</ng-template>
<ng-template #communication>
  <div class="row">
    <div class="col-1"></div>
    <div class="col-10">
      <p class="message text-uppercase">communication</p>
      <hr>
      <p class="commande text-uppercase"> commande </p>
      <mat-form-field [formGroup]="registerForm" style="width: 60%;" (submit)="submitFormCommunication()"
                      appearance="fill"
                      class="mb-3">
        <mat-select formControlName="commandType" [(ngModel)]="selectedCommand"
                    [ngClass]="{'disabledCommunication': spinnerActive != false || getdt ==null}">
          <mat-option (click)="getValueSelect(option.value)" [(value)]="option.value"
                      *ngFor="let option of commandLine">{{ option.viewValue }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <div [formGroup]="registerForm" (submit)="submitFormCommunication()" *ngIf="command == 18" class="display-flex">

        <p>DELETE UNSENT CSA EVENTS</p>  <input
        style="margin-top: 3px;margin-left: 4px" type="radio"
        formControlName="action" value="0"/><br>

        <p style="margin-left: 12%;"> DELETE ALL FILES OTHER THAN EDR FILES </p>
        <input style="margin-top: 3px;margin-left: 4px"
               type="radio"
               formControlName="action" value="1"/> <br>
      </div>

      <div [formGroup]="registerForm" *ngIf="command == 56" aria-label="Select an option">
        <input type="radio" formControlName="action" value="0"/> PRIVATE <br>
        <input type="radio" formControlName="action" value="1"/> LARGE VAN <br>
        <input type="radio" formControlName="action" value="2"/> LIGHT TRUCK <br>
        <input type="radio" formControlName="action" value="3"/> HEAVY TRUCK <br>
      </div>

      <div [formGroup]="registerForm" *ngIf="command == 20">
        <input type="radio" formControlName="action" value="0"/> REQUEST CALIBRATION STATUS <br>
        <input type="radio" formControlName="action" value="1"/> LEAVE CALIBRATED MODE <br>
        <input type="radio" formControlName="action" value="2"/> ENTER CALIBRATED MODE <br>

      </div>
      <div class=" justify-content-end d-flex mt-2 mb-1">
        <a style="margin-right: 81%;margin-top: 3%;" class="savebtn mr-2" type="submit"
           [ngClass]="{'disabled': !registerForm.valid ,'disabledCommunication': spinnerActive != false || getdt ==null }"
           (click)="submitFormCommunication()">Envoyer</a>

      </div>
    </div>
  </div>
</ng-template>
